import React from 'react'
import {Divider, Steps, Row, Col, Input, Select, Pagination, DatePicker,
    Button, Table, Popconfirm, TreeSelect, Tooltip, message,
    BackTop, Spin, Tabs} from 'antd'
import common from '@/public/common'
import './list.less'
import { withRouter } from 'react-router-dom'
import {ajaxApi, fileDownloadApiNew, getMethod, submitMethod} from '@/server'
import { summation, getCookie, getCookieNew, getParmUrl, outputMoney } from '../../public/utils'
import DateChoose from '../../compenents/dateChoose'
import moment from 'moment'
const { Step } = Steps
const { Option } = Select
const { TabPane } = Tabs
const host = window.location.host
const urlLink = common.SapUrl

class SendList extends React.Component{
   constructor(props) {
       super(props)
       this.state = {
         num: {
            all: 0,
            wait_submit: 0,
            wait_sign: 0,
            has_sign: 0,
            has_rejection: 0,
            has_cancel: 0
         },
         search: {
           type: '',
         },
         sping: false,
         data: [],
         current: 1,
         pageNo: 1,
         pageSize: 15 ,
         total: 0,
         status: '',
       }
   }
   componentDidMount () {
     this.getList()
   }
   getList = () => {
       this.setState({
           sping: true
       }, () => {
        let param = {
            page_no: this.state.pageNo,
            page_size: this.state.pageSize,
            status: this.state.status,
            ...this.state.search,
            scs_name: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).real_name : ''
        }
        ajaxApi({
            url: urlLink + '/document/query-list-out',
            params: param
        }).then((res) => {
            if (res.data) {
               this.setState({
                  data: res.data.data,
                  total: res.data.total_count,
                  num: res.data.countpo,
                  sping: false
               }, () => {
                   console.log(this.state.num)
               })
            }
        })
       })
   }
   // 搜索条件input框值更改
   changeInput = (name, val) => {
      let _obj = this.state.search
      _obj[name] = val.target.value
      this.setState({
          search: _obj
      })
   }
   // 搜索条件单据类型更改值
   onChangeSelect = (val) => {
     let _obj = this.state.search
     _obj.type = val
     this.setState({
        search: _obj
    })
   }
     // 时间选择
   changTime = (val) => {
        let _info = this.state.search
        if (!val) {
            _info.send_end_time = ''
            _info.send_begin_time = ''
        } else {
            _info.send_begin_time = new Date(val[0]).getTime()
            _info.send_end_time = new Date(val[1]).getTime()
        }
        this.setState({
            search: _info
        })
    }
   // 搜索
   search = () => {
       this.setState({
           pageNo: 1,
           current: 1,
           pageSize: 15
       }, () => {
        this.getList()
       })
   }
   callback = (val) => {
     this.setState({
         status: val
     }, () => {
         this.getList()
     })
   }
   addSend = () => {
       window.open('http://' + host + '/main/supplierRecantion/addSend')
   }
   // 跳转单据详情/编辑单据
   goDetails = (type, code) => {
       if (type === 'edit') {
        window.open('http://' + host + '/main/supplierRecantion/addSend?code=' + code)
       } else {
        window.open('http://' + host + '/main/supplierRecantion/sendDetails?code=' + code)
       }
   }
   // 作废单据
   confirm = (record) => {
      let param = {
          id: record.id,
          status: 'hasCancel'
      }
      ajaxApi({
          url: urlLink + '/document/update-state',
          params: param
      }).then((res) => {
          if (res) {
              message.success('作废成功！')
              this.getList()
          }
      })
   }
    // 表格分页
    pageOnChange = (val) => {
        this.setState({
            current: val,
            pageNo: val,
        }, () => {
            this.getList()
        })
      }
    sizeOnchange = (current, size) => {
        this.setState({
            current: current,
            pageNo: current,
            pageSize: size
        }, () => {
              this.getList()
        })
    }
    // 导出
    export = () => {
        let _obj ={
            ...this.state.search,
            scs_name: getCookie('supplierinfo') ? JSON.parse(getCookie('supplierinfo')).real_name : ''
        }
        fileDownloadApiNew({
         url: urlLink + '/document/export ',
         param: _obj,
         filename: '寄送单_' + moment().format("YYYYMMDDHHmmss") + '.xls',
        })
    }
    // 上传到视客
    uploadSigo=async(record)=>{
        ajaxApi({
            url: urlLink + '/document/update-state',
            params: {
                id: record.id,
                status: 'waitSign'
            }
        }).then((res) => {
            if (res) {
                message.success('提交成功!')
                this.getList()
            }
        })
    }
   render () {
       const { num, data, total, sping } = this.state
       const columns = [
           {
               title: '寄送单号',
               dataIndex: 'document_code',
               render: (text) => (
               <a onClick={this.goDetails.bind(this, 'details', text)}>{text}</a>
               )
           },
           {
            title: '单据类型',
            dataIndex: 'type_name'
           },
           {
               title: '状态',
               dataIndex: 'status_name'
           },
           {
               title: '寄件人',
               dataIndex: 'sender'
           },
           {
               title: '寄件日期',
               dataIndex: 'send_date',
               render: (text) => (
                  <span>{text ? moment(text).format('YYYY-MM-DD') : ''}</span>
               )
           },
           {
               title: '备注',
               dataIndex: 'remark'
           },
           {
            title: '快递单号',
            dataIndex: 'logistics_code'
            },
            {
                title: '快递公司',
                dataIndex: 'logistics_name'
            },
           {
               title: '操作',
               render: (text, record) => (
                   <div>
                       <a onClick={this.goDetails.bind(this, 'edit', record.document_code)} disabled={record.status === 'waitSubmit' ? false : true}>修改</a>
                       <a  style={{marginLeft:'8px'}} onClick={()=>this.uploadSigo(record)} disabled={record.status!=='waitSubmit'}>提交视客</a>
                       <Popconfirm placement="top" title="作废后单据将关闭无法再操作，你确定还要继续吗？" onConfirm={this.confirm.bind(this, record)} okText="确定" cancelText="取消">
                         <a style={{marginLeft: '5px'}} disabled={record.status === 'waitSubmit' ? false : true}>作废</a>
                       </Popconfirm>
                   </div>
               )
           },

       ]
       return (
           <div className="sendList">
               <Spin spinning={sping}>
               <div className="search">
                   <Row style={{marginBottom: '25px'}}>
                       <Col span={7}>
                            <label>寄送单号：</label>
                            <Input placeholder="请输入寄送单号" style={{width: '60%'}} onChange={this.changeInput.bind(this, 'document_code')}/>
                       </Col>
                       <Col span={7}>
                            <label>快递单号：</label>
                            <Input placeholder="请输入快递单号"  style={{width: '60%'}} onChange={this.changeInput.bind(this, 'logistics_code')}/>
                       </Col>
                       <Col span={7}>
                            <label>文件类型：</label>
                            <Select placeholder="请选择"  style={{width: '60%'}} onSelect={this.onChangeSelect.bind(this)}>
                                <Option value="">请选择</Option>
                                <Option value="A">对账单</Option>
                                <Option value="B">发票</Option>
                                <Option value="C">对账单和发票</Option>
                            </Select>
                       </Col>
                   </Row>
                   <Row>
                      <Col span={7}>
                            <label>&nbsp;&nbsp;&nbsp;寄件人：</label>
                            <Input placeholder="请输入寄件人"  style={{width: '60%'}} onChange={this.changeInput.bind(this, 'sender')}/>
                       </Col>
                       <Col span={16}>
                            <label>寄件日期：</label>
                            <DateChoose
                            ifConvenient={false}
                            isStatus={true}
                            isClick={false}
                            ifshowClear={true}
                            time={true}
                            timerChange={this.changTime}/>
                            <Button type="primary" style={{marginLeft: '20px'}} onClick={this.search} shape="round">查询</Button>
                            <Button style={{marginLeft: '20px'}} onClick={ () => { window.location.reload()}} shape="round">重置</Button>
                            <Button type="primary" style={{marginLeft: '20px'}} onClick={this.export} shape="round">导出</Button>
                       </Col>
                   </Row>
               </div>
               <div className="sendBody">
                <div>
                    <Button type="primary" onClick={this.addSend} shape="round">新增寄送单</Button>
                    <Divider/>
                </div>
                <Tabs defaultActiveKey="" onChange={this.callback}>
                <TabPane tab={"全部（" + num.all + '）'} key="">
                    </TabPane>
                    <TabPane  tab={[<Tooltip title="待提交视客">{"待提交（" + num.wait_submit + '）'}</Tooltip>]} key="waitSubmit">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="待视客签收">{"待签收（" + num.wait_sign + '）'}</Tooltip>]} key="waitSign">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="视客已签收">{"已签收（" + num.has_sign + '）'}</Tooltip>]} key="hasSign">
                    </TabPane>
                    <TabPane tab={[<Tooltip title="视客已拒收">{"已拒收（" + num.has_rejection + '）'}</Tooltip>]} key="hasRejection">
                    </TabPane>
                    <TabPane tab={"已作废（" + num.has_cancel + '）'} key="hasCancel">
                    </TabPane>
                </Tabs>
                <Table columns={columns} dataSource={data} pagination={false}/>
                <div className="pagination">
                    <span className="datanum">{'共' + total + '条数据'}</span>
                   <Pagination showQuickJumper showSizeChanger current={this.state.current} total={total} pageSize={this.state.pageSize} pageSizeOptions={['15', '20', '30', '50', '100']} onChange={this.pageOnChange} onShowSizeChange={this.sizeOnchange} />
                </div>
               </div>
               </Spin>
           </div>
       )
   }
}
export default SendList



// WEBPACK FOOTER //
// ./src/pages/supplierRecantion/sendList.js